module.exports = __webpack_public_path__ + "media/PackLabel_OUT.ac03deb5.mp4";